/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Fc_Wins_5Inputs */

const en_fc_vs_fc_wins_5 = /** @type {(inputs: Fc_Vs_Fc_Wins_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every action is a command. Drive it from the CLI, a JSON channel or an MCP server for automation and AI agents.`)
};

/**
* | output |
* | --- |
* | "Every action is a command. Drive it from the CLI, a JSON channel or an MCP server for automation and AI agents." |
*
* @param {Fc_Vs_Fc_Wins_5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_fc_wins_5 = /** @type {((inputs?: Fc_Vs_Fc_Wins_5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Fc_Wins_5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_fc_wins_5(inputs)
});
export { fc_vs_fc_wins_5 as "fc.vs.fc_wins.5" }